module.exports = __webpack_public_path__ + "static/media/activeAcc.6d72e313.svg";